import { render } from "./SubMenu.vue?vue&type=template&id=94987380&scoped=true&ts=true"
import script from "./SubMenu.vue?vue&type=script&lang=ts"
export * from "./SubMenu.vue?vue&type=script&lang=ts"

import "./SubMenu.vue?vue&type=style&index=0&id=94987380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94987380"]])

export default __exports__